<template>
	<div class="wraper">
		<LeftBar />
		<div
        class="content-cntainer"
        :class="{'menu-opened': getMenu}"
    >
			<TopBar />
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	import LeftBar from '../../components/LeftBar/LeftBar.vue';
	import TopBar from '../../components/TopBar/TopBar.vue';
	import './Layout.scss';
	import { mapGetters } from "vuex"

	export default {
		name: 'Layout',
		components: { LeftBar, TopBar },

		computed: {
		  ...mapGetters('Common', ['getMenu'])
		}
	}
</script>

<style>

</style>
